import type { AuthRole, PanelUser } from '../../shared/types';
import { get, patch, post, remove } from '../../shared/api/http';

export interface CreateUserInput {
  name: string;
  email: string;
  role: AuthRole;
  handle?: string;
  password?: string;
  eventId?: string;
}

export interface UpdateUserInput {
  name?: string;
  handle?: string;
  active?: boolean;
  password?: string;
  eventId?: string | null;
  expiresAt?: string | null;
}

/** Acessos do painel (só ADMIN). */
export const usersApi = {
  list: (role?: AuthRole): Promise<PanelUser[]> => get(`/users${role ? `?role=${role}` : ''}`),
  create: (input: CreateUserInput): Promise<PanelUser & { temporaryPassword?: string }> => post('/users', input),
  update: (id: string, input: UpdateUserInput): Promise<PanelUser> => patch(`/users/${id}`, input),
  remove: (id: string): Promise<void> => remove(`/users/${id}`),
};
